/**
 * A property decorator to be used on base editor properties
 * @param token
 */
import { AppInjector } from '@app/app.injector';
import { InjectToken } from '../types';

// AOT build requires decorator to be a non-arrow function
// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function lazyInject<T>(token: InjectToken<T>): PropertyDecorator {
  return (target: object, propertyKey: string | symbol): void => {
    Object.defineProperty(target, propertyKey, {
      configurable: true,
      get(): any {
        let value;

        try {
          value = this.inject(token);
        } catch (_) {
          value = AppInjector.injector?.get(token);
        }

        // on the very first access to property
        // redefine the property of the instance to have a regular resolved value
        // then, prototype getter will never be called again
        // tslint:disable-next-line:no-invalid-this
        Object.defineProperty(this, propertyKey, {
          // tslint:disable-next-line:no-invalid-this
          value,
        });

        // tslint:disable-next-line:no-invalid-this
        return this[propertyKey];
      },
    });
  };
}
